"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var usePatchElement_1 = tslib_1.__importDefault(require("../../../util/hooks/usePatchElement"));
var confirm_1 = require("../confirm");
var HookModal_1 = tslib_1.__importDefault(require("./HookModal"));
var uuid = 0;
var ElementsHolder = React.memo(React.forwardRef(function (_props, ref) {
    var _a = tslib_1.__read((0, usePatchElement_1.default)(), 2), elements = _a[0], patchElement = _a[1];
    React.useImperativeHandle(ref, function () { return ({
        patchElement: patchElement,
    }); }, []);
    return React.createElement(React.Fragment, null, elements);
}));
function useModal() {
    var holderRef = React.useRef(null);
    var getConfirmFunc = React.useCallback(function (withFunc) {
        return function hookConfirm(config) {
            var _a;
            uuid += 1;
            var modalRef = React.createRef();
            // eslint-disable-next-line prefer-const
            var closeFunc;
            var modal = (React.createElement(HookModal_1.default, { key: "modal-".concat(uuid), config: withFunc(config), ref: modalRef, afterClose: function () {
                    closeFunc();
                } }));
            closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
            return {
                destroy: function () {
                    if (modalRef.current) {
                        modalRef.current.destroy();
                    }
                },
                update: function (newConfig) {
                    if (modalRef.current) {
                        modalRef.current.update(newConfig);
                    }
                },
            };
        };
    }, []);
    var fns = React.useMemo(function () { return ({
        info: getConfirmFunc(confirm_1.withInfo),
        success: getConfirmFunc(confirm_1.withSuccess),
        error: getConfirmFunc(confirm_1.withError),
        delete: getConfirmFunc(confirm_1.withDelete),
        warning: getConfirmFunc(confirm_1.withWarn),
        confirm: getConfirmFunc(confirm_1.withConfirm),
    }); }, []);
    // @ts-ignore
    // eslint-disable-next-line react/jsx-key
    return [fns, React.createElement(ElementsHolder, { ref: holderRef })];
}
exports.default = useModal;
//# sourceMappingURL=index.js.map